<template>
  <div class="search-min-input">
    <span class="search-min-input__yen-mark">¥</span>
    <input
      v-model.number="value"
      type="number"
      :class="{
        'input-form--min': !isInputted,
        'input-form--min--inputted': isInputted,
        'input-form--min--error': hasError
      }"
      :placeholder="placeholder"
      @input="onInput"
    />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultValue: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    }
  },
  data() {
    return {
      value: null
    }
  },
  computed: {
    isInputted() {
      return this.value !== null
    }
  },
  mounted() {
    this.value = this.defaultValue
  },
  methods: {
    onInput() {
      this.$emit('inputted', this.value !== '' ? this.value : null)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-min-input {
  &__yen-mark {
    font-size: 1.6rem;
    padding-right: 8px;
  }

  .input-form--min {
    font-size: 1.6rem;
    width: 100px;

    &--inputted {
      width: 100px;
    }
  }
}
</style>
